export default "__VITE_ASSET__DhvbHxE6__"